var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2195 57.4863C29.8909 46.9798 43.0241 35.7569 53.2919 35.5181C54.0082 35.5181 54.7246 35.2794 55.2021 34.8018C55.6797 34.563 56.1573 34.3242 56.3961 33.6079C59.9778 26.9219 58.0675 21.6686 52.0979 17.3705C45.1732 12.356 34.1891 17.3705 28.697 21.9074C14.8475 33.3691 0.759212 53.1878 1.47557 72.0522C-0.912281 84.7082 -0.434712 98.3185 3.14706 109.541C5.53491 116.705 12.4597 120.287 19.6232 120.764C26.7867 121.242 41.5914 123.391 48.0386 119.093C54.4858 114.795 54.9633 106.437 55.6797 99.274C56.396 91.3941 58.5451 76.5891 51.8591 70.3807C45.1732 64.4111 26.0704 70.8583 28.2195 57.4863Z",
    fill: "#EAE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.024 57.4863C108.696 46.9798 121.828 35.7569 132.097 35.5181C132.813 35.5181 133.529 35.2794 134.007 34.8018C134.485 34.563 134.962 34.3242 135.201 33.6079C138.783 26.9219 136.873 21.6686 130.903 17.3705C123.978 12.356 112.994 17.3705 107.502 21.9074C93.6522 33.3691 79.5639 53.1882 80.2803 72.0522C77.8924 84.7082 78.37 98.3185 81.9514 109.541C84.3392 116.705 91.264 120.287 98.4279 120.764C105.591 121.242 120.396 123.391 126.843 119.093C133.29 114.795 133.768 106.437 134.484 99.274C135.201 91.3941 137.35 76.5891 130.664 70.3807C123.978 64.4111 104.636 70.8583 107.024 57.4863Z",
    fill: "#EAE4D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_1743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.878f07f684f6d42b37d046332da1d6fa.svg";
export { ForwardRef as ReactComponent };